var React = require('react');

function TicketAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 208v-96a48 48 0 0 0-48-48H48a48 48 0 0 0-48 48v96a48 48 0 0 1 0 96v96a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48v-96a48 48 0 0 1 0-96zm-96 176H96V128h384z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480 128v256H96V128z","className":"fa-primary","key":2})]);
}

TicketAlt.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = TicketAlt;

TicketAlt.default = TicketAlt;
